export const isQuotaExceededError = (error: unknown): boolean => {
  if (!(error instanceof DOMException)) {
    return false;
  }

  return (
    error.name === "QuotaExceededError" ||
    error.name === "NS_ERROR_DOM_QUOTA_REACHED"
  );
};

type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

const getLocalStorage = (): Storage | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const createSafeLocalStorage = (
  onQuotaExceeded?: () => void
): StorageLike => {
  let didWarn = false;

  const warnOnce = () => {
    if (didWarn) return;
    didWarn = true;
    onQuotaExceeded?.();
  };

  return {
    getItem: (key) => {
      const storage = getLocalStorage();
      if (!storage) return null;
      try {
        return storage.getItem(key);
      } catch {
        return null;
      }
    },
    setItem: (key, value) => {
      const storage = getLocalStorage();
      if (!storage) return;
      try {
        storage.setItem(key, value);
      } catch (error) {
        if (isQuotaExceededError(error)) {
          warnOnce();
        }
      }
    },
    removeItem: (key) => {
      const storage = getLocalStorage();
      if (!storage) return;
      try {
        storage.removeItem(key);
      } catch {
        // Ignore removal errors.
      }
    },
  };
};
